import InputMaskContainer from "../../../../components/formsAndTable/forms/formControls/inputMask";

const InputMark = () => {
  return <InputMaskContainer />;
};

export default InputMark;
